import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ElasticsearchMultiAnalyzerListComponent } from '@libs/shared/ui/elasticsearch-term-analyzer/elasticsearch-multi-analyzer-list.component';
import { SearchBarComponent } from '@libs/shared/ui/search-bar/search-bar/search-bar.component';

@Component({
  selector: 'app-elasticsearch-multiple-analyzer',
  standalone: true,
  imports: [ElasticsearchMultiAnalyzerListComponent, SearchBarComponent],
  template: `
    <div class="flex w-full flex-col gap-2">
      <app-search-bar
        class="flex-auto"
        placeholder="Index 키워드를 입력 후 엔터를 누르세요."
        (bySearch)="onTypeIndexTerm($event)"
        (byEnterPressed)="onAnalyzeTerm()" />
      <app-search-bar
        class="flex-auto"
        placeholder="Search 키워드를 입력 후 엔터를 누르세요."
        (bySearch)="onTypeSearchTerm($event)"
        (byEnterPressed)="onAnalyzeTerm()" />
    </div>
    <div class="p-4">
      <app-elasticsearch-multi-analyzer-list
        [indexKeyword]="indexKeyword"
        [searchKeyword]="searchKeyword" />
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElasticsearchMultiAnalyzerComponent {
  constructor() {}

  indexTerm = '';
  searchTerm = '';

  indexKeyword = '';
  searchKeyword = '';

  onTypeIndexTerm($event: string) {
    this.indexTerm = $event;
  }

  onTypeSearchTerm($event: string) {
    this.searchTerm = $event;
  }

  onAnalyzeTerm() {
    if (!this.indexTerm || !this.searchTerm) return;
    this.indexKeyword = this.indexTerm;
    this.searchKeyword = this.searchTerm;
  }
}
